// Distribución
export default {};
